import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'

import { Box, Stack, Typography } from '@mui/material'
import { Input } from 'Components/Input'

export default function ProfilForm({ updateReports, setOpen, inputField }) {
  const { handleSubmit, reset, control } = useForm({})

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const response = await makePostRequest('/api/Professional/profil-utilisateur/', data, {}, true)
    if (response.status === 200) {
      updateReports()
      handleClose()
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        className="no-drag"
        open={true}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            bgcolor: '#f7f9fc',
          },
        }}
      >
        <DialogTitle sx={{ color: '#ffffff !important', bgcolor: '#06295f', px: 4, py: 3 }}>
          <Typography sx={{ fontWeight: 850, fontSize: 23 }}>Profil utilisateur</Typography>
          <Typography sx={{ color: 'rgba(255, 255, 255, 0.72)', fontSize: 14, mt: 0.75 }}>
            Renseigne les informations clés pour personnaliser tes recommandations.
          </Typography>
        </DialogTitle>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <DialogContent sx={{ px: 3, py: 2.5 }}>
            <Stack gap={1}>
              {inputField &&
                inputField.map((val, idx) => (
                  <Input
                    key={idx}
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      required: true,
                      size: 'small',
                      type: val.type || 'text',
                      inputProps: val.type === 'number' ? { min: 0 } : undefined,
                    }}
                    defaultValue={val.value}
                    rules={{ required: true }}
                    name={val.name}
                    label={val.label}
                  />
                ))}
            </Stack>
          </DialogContent>
          <DialogActions sx={{ px: 4, pb: 3, gap: 1 }}>
            <Button
              onClick={() => {
                handleClose()
              }}
              sx={{ color: '#526173', fontWeight: 700 }}
            >
              Annuler
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                bgcolor: '#1b75d0',
                borderRadius: 999,
                px: 3,
                fontWeight: 800,
                textTransform: 'none',
                '&:hover': { bgcolor: '#145da8' },
              }}
            >
              Valider
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}
